<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    center
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="终端名称" prop="app_name">
        <el-input v-model="form.app_name" placeholder="请输入终端名称" maxlength="50" />
      </el-form-item>
      
      <el-form-item label="终端类型" prop="os_type">
        <el-select v-model="form.os_type" placeholder="请选择终端类型" style="width: 100%">
          <el-option label="Android" :value="1" />
          <el-option label="iOS" :value="2" />
          <el-option label="web" :value="4" />
          <el-option label="h5" :value="8" />
        </el-select>
      </el-form-item>
      
      <el-form-item label="版本号" prop="version">
        <el-input v-model="form.version" placeholder="请输入版本号，如：1.0.0" maxlength="20" />
      </el-form-item>
      
      <el-form-item label="上传客户端" prop="upload_url">
        <el-upload
          class="upload-client"
          :action="uploadAction"
          :headers="uploadHeaders"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :show-file-list="false"
          accept=".apk,.ipa,.exe,.zip,.rar"
        >
          <el-button size="small" type="primary" icon="el-icon-upload2">
            选择文件
          </el-button>
          <div slot="tip" class="el-upload__tip">
            支持 .apk/.ipa/.exe/.zip/.rar 格式文件，大小不超过50MB
          </div>
        </el-upload>
        <div v-if="form.upload_url" class="upload-result">
          <i class="el-icon-document"></i>
          <span class="file-name">{{ getFileName(form.upload_url) }}</span>
          <el-button 
            type="text" 
            size="mini" 
            @click="removeFile"
            style="color: #f56c6c; margin-left: 10px;"
          >
            删除
          </el-button>
        </div>
      </el-form-item>
      
      <el-form-item label="备注" prop="note">
        <el-input
          v-model="form.note"
          type="textarea"
          :rows="3"
          placeholder="请输入备注信息"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
      
      <el-form-item label="状态" prop="disabled">
        <el-select v-model="form.disabled" placeholder="请选择状态" style="width: 100%">
          <el-option label="启用" :value="false" />
          <el-option label="禁用" :value="true" />
        </el-select>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveAppVersion } from '@/api/custom-frontend'

export default {
  name: 'VersionEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    appInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      uploadAction: process.env.VUE_APP_BASE_URL + '/v1/admin/cmn/upload',
      uploadHeaders: {
        'AppKey': 'BpLnfgDs'
      },
      form: {
        id: null,
        app_id: '',
        app_name: '',
        os_type: '',
        version: '',
        upload_url: '',
        note: '',
        disabled: false
      },
      rules: {
        app_name: [
          { required: true, message: '请输入终端名称', trigger: 'blur' },
          { max: 50, message: '终端名称不能超过50个字符', trigger: 'blur' }
        ],
        os_type: [
          { required: true, message: '请选择终端类型', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
          { max: 20, message: '版本号不能超过20个字符', trigger: 'blur' }
        ],
        upload_url: [
          { required: true, message: '请输入上传客户端地址', trigger: 'blur' },
          { max: 500, message: '上传客户端地址不能超过500个字符', trigger: 'blur' }
        ],
        note: [
          { max: 500, message: '备注不能超过500个字符', trigger: 'blur' }
        ],
        disabled: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    },
    formData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form = { ...val }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    },
    appInfo: {
      handler(val) {
        if (val && val.id) {
          this.form.app_id = val.id
        }
      },
      immediate: true
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: null,
        app_id: this.appInfo.id || '',
        app_name: '',
        os_type: '',
        version: '',
        upload_url: '',
        note: '',
        disabled: false
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    async handleSave() {
      try {
        await this.$refs.form.validate()
        
        const data = { ...this.form }
        if (!data.id) {
          delete data.id
        }
        
        const res = await saveAppVersion(data)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('save')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    },
    
    // 文件上传前的校验
    beforeUpload(file) {
      const allowedTypes = ['application/vnd.android.package-archive', 'application/x-ios-app', 'application/x-msdownload', 'application/zip', 'application/x-rar-compressed']
      const allowedExtensions = ['.apk', '.ipa', '.exe', '.zip', '.rar']
      const maxSize = 50 * 1024 * 1024 // 50MB
      
      // 检查文件类型
      const fileName = file.name.toLowerCase()
      const isValidType = allowedExtensions.some(ext => fileName.endsWith(ext))
      
      if (!isValidType) {
        this.$message.error('只能上传 .apk/.ipa/.exe/.zip/.rar 格式文件！')
        return false
      }
      
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过50MB！')
        return false
      }
      
      return true
    },
    
    // 文件上传成功
    handleUploadSuccess(response, file) {
      if (response && response.err_code === 0) {
        this.form.upload_url = response.data.url || response.data.file_url
        this.$message.success('文件上传成功')
      } else {
        this.$message.error(response.err_msg || '文件上传失败')
      }
    },
    
    // 文件上传失败
    handleUploadError(error) {
      console.error('文件上传失败:', error)
      this.$message.error('文件上传失败，请重试')
    },
    
    // 删除文件
    removeFile() {
      this.form.upload_url = ''
    },
    
    // 获取文件名
    getFileName(url) {
      if (!url) return ''
      const fileName = url.split('/').pop()
      return fileName || '未知文件'
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: right;
}

.upload-client {
  ::v-deep .el-upload {
    display: block;
  }
  
  ::v-deep .el-upload__tip {
    margin-top: 8px;
    color: #999;
    font-size: 12px;
    line-height: 1.4;
  }
}

.upload-result {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  display: flex;
  align-items: center;
  
  .file-name {
    margin-left: 8px;
    color: #606266;
    flex: 1;
    word-break: break-all;
  }
}
</style>